import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { AmericanCountryList, EuropeanUnionList, PROVIDER_SOURCE, UKCountryList } from 'libs/uikit/src/constants/quote';
import SwitchCountryView from './switchCountry';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PriceComparisonOnlyJoveBasicInfoView = function PriceComparisonOnlyJoveBasicInfoView(props) {
  var _info$jove_quote_pric, _info$jove_quote_pric2;

  var className = props.className,
      valueChange = props.valueChange,
      defaultCountry = props.defaultCountry,
      disableSwitchCountry = props.disableSwitchCountry,
      hideCountry = props.hideCountry,
      info = props.info;
  /**
   * methods
   */

  var countrySelectChangeAction = function countrySelectChangeAction(value) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange({
      country: value,
      businessCountry: value
    });
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('relative flex flex-col space-y-4', className),
    children: [/*#__PURE__*/_jsx("img", {
      src: "https://storage.googleapis.com/jove-public-images/quote/quote-switch-to-jove-header-1.png",
      className: "absolute right-0 top-0 h-auto w-2/3",
      alt: "Header"
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      className: "text-black-secondary z-10 text-2xl font-black",
      children: "Jove insurance"
    }), !hideCountry && /*#__PURE__*/_jsx(SwitchCountryView, {
      valueChange: countrySelectChangeAction,
      defaultCountry: defaultCountry,
      disableSwitchCountry: disableSwitchCountry || [PROVIDER_SOURCE().GREATEAMERICAN.value].includes(info === null || info === void 0 ? void 0 : (_info$jove_quote_pric = info.jove_quote_price) === null || _info$jove_quote_pric === void 0 ? void 0 : _info$jove_quote_pric.provider_code),
      allowSelectCountryList: [PROVIDER_SOURCE().GREATEAMERICAN.value].includes(info === null || info === void 0 ? void 0 : (_info$jove_quote_pric2 = info.jove_quote_price) === null || _info$jove_quote_pric2 === void 0 ? void 0 : _info$jove_quote_pric2.provider_code) ? _toConsumableArray(AmericanCountryList) : [].concat(_toConsumableArray(UKCountryList), _toConsumableArray(EuropeanUnionList))
    })]
  });
};

export default PriceComparisonOnlyJoveBasicInfoView;